import { render, staticRenderFns } from "./PublicPartnersRegistration.vue?vue&type=template&id=79d834fa"
import script from "./PublicPartnersRegistration.vue?vue&type=script&lang=js"
export * from "./PublicPartnersRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports